import * as lucideIcons from "lucide-react";
import { twMerge } from "tailwind-merge";
import React from "react";
                       
interface LucideProps extends React.ComponentPropsWithoutRef<"svg"> {
    icon: string;
    title?: string;
}

function Lucide({
    icon,
    className,
    ...computedProps
}: LucideProps) {
    const Icon = lucideIcons[
        icon as keyof typeof lucideIcons
    ] as React.ComponentType<React.ComponentProps<"svg">> | undefined;

    if (!Icon) {
        console.warn(`[Lucide] Icon not found: "${icon}"`);
        return null;
    }

    return React.createElement(Icon, {
        ...computedProps,
        className: twMerge(
            "stroke-1.5 w-5 h-5",
            className
        ),
    });
}

export default Lucide;